module.exports = __webpack_public_path__ + "static/img/img-features-feature-5-accessibility_ko.27296b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-5-accessibility_ko.png
// module id = MScR
// module chunks = 18